module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Dialog', {
    style: ({
      width: '40vw'
    }),
    attrs: {
      "visible": _vm.value,
      "header": "Are you sure you want to delete?",
      "modal": true,
      "closable": false
    },
    on: {
      "update:visible": function($event) {
        _vm.value = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Delete"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.deleted.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid"
  }, [_c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "for": "deleteReason"
    }
  }, [_vm._v("Delete Reason:")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('Textarea', {
    attrs: {
      "id": "deleteReason",
      "rows": "5"
    },
    model: {
      value: (_vm.deleteReason),
      callback: function($$v) {
        _vm.deleteReason = $$v
      },
      expression: "deleteReason"
    }
  })], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c5800a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/dialog.vue
// module id = 2165
// module chunks = 0